// src/services/contacts.ts
import { apiJson } from './http';

/* -------- CONTACT -------- */
export type SectorDTO = { id: number; name: string; icon?: string | null; active: boolean };

export type ContactDTO = {
  id: number;
  firstName?: string | null;
  lastName?: string | null;
  businessName?: string | null;        // azienda
  email?: string | null;
  phone?: string | null;
  website?: string | null;
  notes?: string | null;
  isActive?: boolean;
  createdAt?: string;
  updatedAt?: string;

  // nuovi campi BE
  lastActivityAt?: string | null;      // ISO della MAX occurredAt tra le attività
  isCustomer?: boolean;                // nuovo campo entity/DTO
  isCustomerSince?: string | null;     // ISO date (YYYY-MM-DD) nuovo campo entity/DTO

  // opzionale (solo se il BE lo fornisce)
  lastActivityType?: string | null;    // es. label/typeCode lato BE
  sector?: SectorDTO | null;
};

export type CreateContactRequest = {
  firstName?: string;
  lastName?: string;
  businessName?: string;
  email?: string;
  phone?: string;
  website?: string;
  notes?: string;
  sectorId?: number | null;
  active?: boolean;
  // NOTA: isCustomer/isCustomerSince NON sono previsti nel create/update payload lato BE in questo momento
};

export async function listContacts(): Promise<ContactDTO[]> {
  return apiJson<ContactDTO[]>('/p/contacts');
}

export async function getContact(id: number): Promise<ContactDTO> {
  return apiJson<ContactDTO>(`/p/contacts/${id}`);
}

export async function createContact(payload: CreateContactRequest): Promise<ContactDTO> {
  return apiJson<ContactDTO>('/p/contacts', {
    method: 'POST',
    body: JSON.stringify(payload),
  });
}

export async function updateContact(id: number, payload: Partial<CreateContactRequest>): Promise<ContactDTO> {
  return apiJson<ContactDTO>(`/p/contacts/${id}`, {
    method: 'PUT',
    body: JSON.stringify(payload),
  });
}

export async function deleteContact(id: number): Promise<void> {
  await apiJson<void>(`/p/contacts/${id}`, { method: 'DELETE' });
}

export async function convertContactToCustomer(id: number): Promise<{ customerId: number }> {
  return apiJson<{ customerId: number }>(`/p/contacts/${id}/convert`, { method: 'POST' });
}

/* -------- CONTACT ACTIVITIES -------- */
export type ContactActivityDTO = {
  id: number;
  contactId: number;
  typeId: number;
  typeLabel: string;
  typeIcon?: string | null;
  notes?: string | null;
  occurredAt: string;   // ISO
  createdAt?: string;
};

export type CreateContactActivityRequest = {
  typeId: number;
  notes?: string;       // usa "notes" (non "note")
  occurredAt?: string;  // ISO
  userId?: number;      // opzionale
};

export async function listContactActivities(contactId: number): Promise<ContactActivityDTO[]> {
  return apiJson<ContactActivityDTO[]>(`/p/contacts/${contactId}/activities`);
}

export async function createContactActivity(
  contactId: number,
  payload: CreateContactActivityRequest
): Promise<ContactActivityDTO> {
  return apiJson<ContactActivityDTO>(`/p/contacts/${contactId}/activities`, {
    method: 'POST',
    body: JSON.stringify(payload),
  });
}

export async function deleteContactActivity(contactId: number, activityId: number): Promise<void> {
  await apiJson<void>(`/p/contacts/${contactId}/activities/${activityId}`, { method: 'DELETE' });
}


export async function markContactAsCustomer(id: number, sinceISO?: string): Promise<ContactDTO> {
  const body = sinceISO ? JSON.stringify({ since: sinceISO }) : undefined;
  return apiJson<ContactDTO>(`/p/contacts/${id}/mark-customer`, {
    method: 'POST',
    body,
  });
}